import OffersPage from 'components/pages/OfferPages';
import FreeOffersPageDescription from 'components/pages/OfferPages/FreeOffers/PageDescription';

import { resolvify } from 'lib/promises';
import { offerQueryKeys } from 'lib/queryKeys';

import { getAds } from 'services/ads';
import { getTagArticlesList } from 'services/article';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getFreeOffersList, getTopOffersList } from 'services/offer';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';

const GA_EVENT_CATEGORY = 'free_offer_page';
const OFFERS_FILTER_VALUE = 'free';
const OFFERS_SERVER_LIMIT = 24;
const HEADING_TITLE = 'Ofertas grátis';
const PAGE_TITLE = 'Ofertas grátis no Promobit';
const RELATED_ARTICLES_LIMIT = 3;
const LOWEST_PRICE_OFFERS_LIMIT = 5;

const Gratis = (props) => (
  <OffersPage
    apiEndpointRequestFn={(...rest) => getFreeOffersList(...rest)}
    gaEventCategory={GA_EVENT_CATEGORY}
    headingTitle={HEADING_TITLE}
    offersListProps={{ showButtonBeforeFirstPagination: true }}
    pageDescriptionComponent={<FreeOffersPageDescription />}
    pageTitle={PAGE_TITLE}
    queryKey={(offersSort) =>
      offerQueryKeys.listFilteredBy({
        value: OFFERS_FILTER_VALUE,
        offersSort,
      })
    }
    {...props}
  />
);

export const getServerSideProps = async ({ query }) => {
  try {
    const [
      freeOffers,
      { articles: relatedArticles },
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      { offers: topOffers },
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getFreeOffersList({ limit: OFFERS_SERVER_LIMIT, ...query }),
      {
        fn: getTagArticlesList({
          tagSlug: 'gratis',
          limit: RELATED_ARTICLES_LIMIT,
        }),
        fallback: getTagArticlesList.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getTopOffersList({ limit: LOWEST_PRICE_OFFERS_LIMIT }),
        fallback: getTopOffersList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        relatedArticles,
        serverOffers: freeOffers,
        sidebarProps: { topOffers },
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default Gratis;
